import React from 'react'
import './Spin.css'

export default () => (
  <section className="Spin">
    <div className="three-bounce">
      <div className="one" />
      <div className="two" />
      <div className="three" />
    </div>
  </section>
)
